import { Observable } from 'rxjs';
import { SiguientesPasosResponse } from '../interfaces/siguientes-pasos-response';


export abstract class SiguientesPasosService {

    abstract obtenerSiguientesPasos(): Observable<SiguientesPasosResponse>;
}
